module.exports = __webpack_public_path__ + "img/0-84.7f641ce0.jpg";